import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';

import Nav from './components/Nav';
import Content from './components/Content';
import ErrorBoundary from './components/ErrorBoundary';
import { ErrorBlock } from './components/Block';
import routes from './routes';

require(`./themes/${process.env.THEME}/main.sass`);

Sentry.setTag('theme', process.env.THEME || 'not defined');

export default function App() {
  const { t } = useTranslation();

  return (
    <>
      <Nav />
      <main>
        <div className="container">
          <ErrorBoundary
            fallback={
              <ErrorBlock headerText={t('Error')} text={t('DefaultError')}>
                <button
                  className="btn"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  {t('reload')}
                </button>
              </ErrorBlock>
            }
            severity={'critical'}
          >
            <Content routes={routes} />
          </ErrorBoundary>
        </div>
      </main>
    </>
  );
}
